<template>
  <!--根组件，其他的组件都包含在该组件中 -->
  <div id="app">
    <!-- <img src="./assets/ts.png"> -->
    <!--router-view：是一个容器，路由视图，意思是当前路由（URL）指向的内容将显示在这个容器中    v-if="isRouterAlive" -->
    <router-view />
    <ScrollTop></ScrollTop>
  </div>
</template>

<script>
import ScrollTop from "./components/common/ScrollTop";
// export default ：意思是将这个组件整体导出，之后就可以使用import导入组件了
export default {
  name: "App",
  components: {
    ScrollTop,
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue